
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/privateAppsPanel/components/appReleaseNotes/appReleaseNotes.scss.css.virtualfile';
        module.exports = {"title":"_title_askho_1","content":"_content_askho_4","container":"_container_askho_7"};